import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PlanService } from '../../../core/services/plan.service';

export const trialVencidoGuard: CanActivateFn = () => {
  const planService = inject(PlanService);
  const router = inject(Router);

  const plan = planService.plan();
  const trialVencido =
    plan.status === 'trial' && (planService.trialDaysRemaining() ?? 0) === 0;

  if (trialVencido) {
    return router.createUrlTree(['/billing/planos']);
  }
  return true;
};
